import { ROLE_ADMIN, ROLE_PARTNER_ADMIN, ROLE_SUPERADMIN,ROLE_PARTNER_USER,ROLE_USER } from '../../constants/roles';
import { createHasSettingsAccessSelector } from '../session';

export const selectHasSettingsAccess = createHasSettingsAccessSelector([ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN])

export const selectHasAboutAccess = createHasSettingsAccessSelector([ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER_ADMIN,ROLE_PARTNER_USER,ROLE_USER])
